// extracted by mini-css-extract-plugin
export default {"V2FormCheckbox":"V2FormCheckbox--z9htx","markerAnimationScale":"markerAnimationScale--pHhKp"};